// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// $FlowFixMe
import { isEmpty, isNil, get } from 'lodash/fp';
import AccountConstants from 'logic/data/Izenda.AccountConstants';
import SettingConstants from 'logic/data/Izenda.SettingConstants';
import AppStore from 'logic/Izenda.AppStore';
import uiState from 'logic/Izenda.UiState.js';
import { action } from 'mobx';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import routeUtils from 'share/utils/Izenda.RouteUtils';

const MESSAGE_TYPE = CommonMessages.MESSAGE_TYPE;

export default {
  /**
   * Check show organization.
   */
  checkShowOrganization() {
    return function checkShowOrganization(store: any) {
      store.model.updateProperty('enableForEnter', false);
      return store.loadSystemMode().then(
        action(result => {
          store.model.updateProperty(
            'hasOrg',
            result.systemMode === SettingConstants.TENANT_MODE && result.allowDuplicateUser
          );
          store.model.updateProperty('enableForEnter', true);
          return Promise.resolve(true);
        })
      );
    };
  },

  /**
   * Set up auth information
   * @param  {Object} result - login result
   * @param  {Object} props
   */
  setUpAuthInfo(result: any, props: any, url: string, fromLoginPage: boolean = false): any {
    const data = result.data || {};

    props.authorization.setAccessToken(data.token);
    const defaultLink = props.authorization.getDefaultLink(
      routeUtils,
      fromLoginPage && isEmpty(get('licenseInfoStore.licenseInfo.licenseStatus', AppStore))
    );
    url = !isNil(url) ? url : defaultLink;

    // rewrite url
    history.replaceState && history.replaceState({}, document.title, url);
    if (localStorage.getItem("redirectUrl") !== null) {
      props.router.push(localStorage.getItem("redirectUrl"));
    } else {
      props.router.replace(url);
    }
    return Promise.resolve(true);
  }
};



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.AccountUtils.js